/**
 *
 * 兼容后续添加的三方企业号小程序支持
 * 
 * 模板：
 * 'sygf': {
		channel: "sygf",
		logo: "https://image.comein.cn/comein-files/img/2022-08-11/48dae385-4b49-427f-9d72-bbbcce76dfa7/48dae385-4b49-427f-9d72-bbbcce76dfa7.jpg",
		title: "视源股份投资者关系",
		desc: "梦想引领未来",
		flagship: false,
		ids: [6740, 20824]
	}
 *
 * ids, 测试渠道id在前，生产渠道id在后
 *
 */

import { isBuild, PDFVIEWERURL } from '../../utils/const';
import { getUrlParam } from '../../utils/api';

const getChannel = getUrlParam().comein_channel;
const pickChannelConfig = window.__irstore_bridge_config[getChannel] || {};
const { channel, logo, title, desc, flagship, ids = [] } = pickChannelConfig;

const comein_channel = channel;
const comein_channel_logo = logo;
const comein_channel_title = title;
const comein_channel_desc = desc;

export const isThirdParty = getChannel === comein_channel;

function getChannelId() {
	const [testId, prodId] = ids;
	return isBuild ? prodId : testId;
}

function Bridge() {
	this.title = comein_channel_title;

	this.comein_channel = comein_channel;

	this.authMethod = 1;

	this.menuType = 'tab';
	this.menuTabList = [
		{
			title: '首页',
			path: '/mobile/flagship/index?id=' + getChannelId() + `&comein_channel=${comein_channel}`,
			icon: '#icon-tab_home',
			active_icon: '#icon-tab_home_pre'
		},
		{
			title: '我',
			path: `/mobile/institute/user?comein_channel=${comein_channel}`,
			icon: '#icon-tab_me',
			active_icon: '#icon-tab_me_pre'
		}
	];

	this.instituteUser = {
		showBought: false
	};

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0]
	};

	if (flagship) {
		// 小程序审核不过，所以发布的时候隐藏了行情以及公告等tab，审核通过，发布之后再放出来。
		this.flagship = {
			hideQuotation: true,
			tabList: ['banner']
			// tabList: [100, 106],
		};
	}

	this.downloadFile = '/pages/download/index?url=';
}

// 重写第三方页面登陆
Bridge.prototype.login = function () {
	// 设置form，用于登录成功后跳转
	wx.miniProgram.navigateTo({
		url: `/pages/login/index?from=${encodeURIComponent(location.pathname + location.search)}`
	});
};

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: comein_channel_title,
		desc: comein_channel_desc,
		link: location.href,
		min_link: '/mobile/flagship/index?id=' + getChannelId() + `&comein_channel=${comein_channel}`,
		img_url: comein_channel_logo,
		min_img_url: comein_channel_logo
	};
};

// 页面跳转 三方小程序的首页是一个webview、页面跳转的时候需要打开一个新的webview、这时候左上角才会有后退按钮。
Bridge.prototype.navigateTo = function (obj) {
	let path = this.$router.resolve(obj).href;

	//判断是否为pdf文件，
	if (path.indexOf('.pdf') > -1) {
		path = `${PDFVIEWERURL}${path}`;
	}
	// 判断url 是否以https://mobile.comein.cn 或https://testmobile.comein.cn开头,如果是则remove掉
	if (path && (path.startsWith('https://mobile.comein.cn') || path.startsWith('https://testmobile.comein.cn'))) {
		path = path.replace('https://mobile.comein.cn', '').replace('https://testmobile.comein.cn', '');
	}

	wx.miniProgram.navigateTo({
		url: `/pages/index/index?url=${encodeURIComponent(path)}`
	});
};

export default Bridge;
